import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/images/favicon.png'


const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black d-print-none" }
const _hoisted_2 = { class: "fw-bold ms-10" }
const _hoisted_3 = { class: "sidebar-menu" }
const _hoisted_4 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_5 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_6 = {
  id: "sidebarCollapseOne",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_7 = { class: "accordion-body" }
const _hoisted_8 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_9 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_10 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_11 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_12 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}
const _hoisted_13 = {
  key: 4,
  class: "sidebar-sub-menu-item"
}
const _hoisted_14 = {
  key: 5,
  class: "sidebar-sub-menu-item"
}
const _hoisted_15 = {
  key: 6,
  class: "sidebar-sub-menu-item"
}
const _hoisted_16 = {
  key: 7,
  class: "sidebar-sub-menu-item"
}
const _hoisted_17 = {
  key: 8,
  class: "sidebar-sub-menu-item"
}
const _hoisted_18 = {
  key: 9,
  class: "sidebar-sub-menu-item"
}
const _hoisted_19 = {
  key: 10,
  class: "sidebar-sub-menu-item"
}
const _hoisted_20 = {
  key: 11,
  class: "sidebar-sub-menu-item"
}
const _hoisted_21 = {
  key: 12,
  class: "sidebar-sub-menu-item"
}
const _hoisted_22 = { class: "sidebar-sub-menu-item" }
const _hoisted_23 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_24 = {
  id: "sideRelatorios",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_25 = { class: "accordion-body" }
const _hoisted_26 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_27 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_28 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_29 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_30 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}

import { defineComponent, reactive, watch } from "vue";
import { useRoute } from "vue-router";
import stateStore from "../../utils/store";
import config from "../../app.config.json"
import { useUserStore } from "@/stores/userStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainSidebar',
  setup(__props) {

const userStore = useUserStore();
const stateStoreInstance = stateStore;
const route = useRoute();

// Abaixo de 1200px o menu é um overlay (classe "active" = visível).
// Ao navegar, fecha o menu para não cobrir o conteúdo no celular/tablet.
watch(() => route.fullPath, () => {
  if (window.innerWidth < 1200 && stateStoreInstance.open) {
    stateStoreInstance.open = false;
  }
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
    'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition d-print-none',
    { active: _unref(stateStoreInstance).open },
  ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: _imports_0,
            alt: "logo-icon"
          }, null, -1)),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(config).empresa), 1)
        ]),
        _: 1
      }),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "border-bottom" }, null, -1)),
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(stateStoreInstance).onChange && _unref(stateStoreInstance).onChange(...args)))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
      ]))])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _cache[18] || (_cache[18] = _createElementVNode("a", {
            href: "#",
            class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#sidebarCollapseOne",
            "aria-expanded": "true",
            "aria-controls": "sidebarCollapseOne"
          }, [
            _createElementVNode("i", { class: "flaticon-more-1" }),
            _createElementVNode("span", { class: "title" }, "Menu")
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("ul", _hoisted_8, [
                (_unref(userStore).hasPermissao('usuarios'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                      _createVNode(_component_router_link, {
                        to: "/usuarios",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode(" Usuários ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('planos'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                      _createVNode(_component_router_link, {
                        to: "/planos",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode(" Planos ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('clientes'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                      _createVNode(_component_router_link, {
                        to: "/clientes",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode(" Clientes ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('empresas'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                      _createVNode(_component_router_link, {
                        to: "/empresas",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode(" Empresas ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('contratos'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                      _createVNode(_component_router_link, {
                        to: "/contratos",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode(" Contratos ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('parceiros'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                      _createVNode(_component_router_link, {
                        to: "/parceiros",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" Parceiros ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('vouchers'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        to: "/vouchers",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode(" Vouchers ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('titulares'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        to: "/titulares",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode(" Diário de ativos ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('contasReceber'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                      _createVNode(_component_router_link, {
                        to: "/contasReceber",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode(" Contas a Receber ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('boletos'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                      _createVNode(_component_router_link, {
                        to: "/boletos",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode(" Cobrança ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('parametros'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                      _createVNode(_component_router_link, {
                        to: "/parametros",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode(" Parâmetros ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).tipoId === 1)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                      _createVNode(_component_router_link, {
                        to: "/permissoes",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode(" Permissões ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).tipoId === 1)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                      _createVNode(_component_router_link, {
                        to: "/logs",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode(" Logs ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", _hoisted_22, [
                  _createVNode(_component_router_link, {
                    to: "/versoes",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode(" Versões ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_23, [
          _cache[23] || (_cache[23] = _createElementVNode("a", {
            href: "#",
            class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#sideRelatorios",
            "aria-expanded": "true",
            "aria-controls": "sideRelatorios"
          }, [
            _createElementVNode("i", { class: "flaticon-more-1" }),
            _createElementVNode("span", { class: "title" }, "Relatórios")
          ], -1)),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("ul", _hoisted_26, [
                (_unref(userStore).hasPermissao('relatorios'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                      _createVNode(_component_router_link, {
                        to: "/relatorios/mensalidades",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode(" Mensalidades ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('relatorios'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                      _createVNode(_component_router_link, {
                        to: "/relatorios/clientes",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createTextVNode(" Clientes ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('relatorios'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                      _createVNode(_component_router_link, {
                        to: "/relatorios/clientescontrato",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createTextVNode(" Clientes X Contrato ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(userStore).hasPermissao('relatorios'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                      _createVNode(_component_router_link, {
                        to: "/relatorios/clientesdependentes",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createTextVNode(" Clientes X Dependentes ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}
}

})